module.exports = "../fonts/vendor/primevue/resources/themes/lara-light-indigo/Inter-Regular.woff2?c8ba52b05a9ef10f47584d08ece2ec5c";